/** The day's food log. */
import type { JSX } from 'preact';
import { Card, Empty, Icons, Meter, fmt } from '../ui/bits';
import { deleteMeal, mealsToday, settings } from '../store';
import { total } from '../domain/macros';
import type { FoodLog } from '../data/schema';

export function Food(props: { onLog: () => void }): JSX.Element {
  const meals = mealsToday.value;
  const goals = settings.value.goals;
  const eaten = total(meals.flatMap((m) => m.items));

  const bySlot = ['breakfast', 'lunch', 'dinner', 'snack']
    .map((slot) => ({ slot, logs: meals.filter((m) => m.slot === slot) }))
    .filter((g) => g.logs.length);

  return (
    <>
      <Card title="Today">
        <Meter label="Calories" value={eaten.kcal} goal={goals.kcal} unit=" kcal" />
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px', marginTop: '12px' }}>
          <Meter label="Protein" value={eaten.protein} goal={goals.protein} unit="g" mini goodWhenFull />
          <Meter label="Carbs" value={eaten.carbs} goal={goals.carbs} unit="g" mini />
          <Meter label="Fat" value={eaten.fat} goal={goals.fat} unit="g" mini />
        </div>
      </Card>

      {bySlot.length === 0 ? (
        <Card>
          <Empty mark={Icons.food}>
            Nothing logged today. Tap Log and describe the meal in plain language.
          </Empty>
        </Card>
      ) : (
        bySlot.map(({ slot, logs }) => (
          <Card key={slot} title={slot} flush>
            <div class="list">
              {logs.map((log) => <MealRow key={log.id} log={log} />)}
            </div>
          </Card>
        ))
      )}
      <button class="fab" onClick={props.onLog} aria-label="Log food">{Icons.plus} Log</button>
    </>
  );
}

function MealRow(props: { log: FoodLog }): JSX.Element {
  const t = total(props.log.items);
  return (
    <div>
      <div class="item" style={{ borderBottom: 'none', paddingBottom: '4px' }}>
        <div class="col grow">
          <span class="item-title">{props.log.items.map((i) => i.name).join(', ')}</span>
          <span class="item-sub">
            P {fmt(t.protein)} · C {fmt(t.carbs)} · F {fmt(t.fat)}
            {props.log.items.some((i) => i.estimated) ? ' · estimated' : ''}
          </span>
        </div>
        <span class="readout readout-sm">{fmt(t.kcal)}<span class="unit"> kcal</span></span>
      </div>
      <div class="row" style={{ padding: '0 14px 10px', justifyContent: 'flex-end' }}>
        <button class="btn btn-sm btn-ghost" onClick={() => void deleteMeal(props.log.id)}>Delete</button>
      </div>
    </div>
  );
}
